<template>
	<div>
		<Admin v-if="auth && userType == 10" />
		<App v-else-if="auth && userType == 30" />
		<Auth v-if="!auth" />
	</div>
</template>

<script>
import Admin from './Admin.vue';
import App from './App.vue';
import Auth from './Auth.vue';
import { mapGetters } from 'vuex';
export default {
	name: 'Provider',
	components: { Admin, App, Auth },
	created() {},
	computed: {
		...mapGetters(['auth', 'userType']),
	},
};
</script>

<style></style>
